import React, { useEffect, Suspense } from 'react';
import {BrowserRouter as Router, Route, Redirect, Switch} from 'react-router-dom'


//import Users from './users/pages/Users';
//import NewPlaces from './places/pages/NewPlaces';
//import UpdatePlace from './places/pages/UpdatePlace';
//import UserPlaces from './places/pages/UserPlaces';
//import Auth from './auth/pages/Auth';

import Card from './shared/components/UIElement/Card/Card';
import {AuthContext} from './shared/context/auth-context';
import useAuth from './shared/hooks/auth-hook';
import MainNav from './shared/components/Navigation/MainNav/MainNav';

import './App.css';
import LoadingSpinner from './shared/components/UIElement/LoadingSpinnier/LoadingSpinner';


const Users = React.lazy(() => import('./users/pages/Users'));
const NewPlaces = React.lazy(() => import('./places/pages/NewPlaces'));
const UpdatePlace = React.lazy(() => import('./places/pages/UpdatePlace'));
const UserPlaces = React.lazy(() => import('./places/pages/UserPlaces'));
const Auth = React.lazy(() => import('./auth/pages/Auth'));


function App() {
  
  let {token, userId, login, logout} = useAuth();
  

  useEffect(() => {
   
    var tag = document.createElement('script');
    tag.src = "https://maps.googleapis.com/maps/api/js?key="+process.env.REACT_APP_GOOGLE_API_KEY;
    tag.onload = function () {console.log("inserted successfully");};
    
    (document.head || document.documentElement).appendChild(tag);

    console.log(process.env.REACT_APP_GOOGLE_API_KEY)
    
  }, [])   


  let routes;
  if(!process.env.REACT_APP_GOOGLE_API_KEY){
        routes = (
            <div className="center">
                <Card>
                    <h3> Google Map Api Key Not Found!</h3>
                    <br/>
                    <small> 
                        Create a '.env' file on the root directory and create the environment variable
                    </small>
                </Card>
            </div>
        )
  }
  else if(token){
        routes = (
            <Switch>
                <Route path="/" exact>
                    <Users/>
                </Route>
                <Route path="/places/new" exact>
                    <NewPlaces/>
                </Route>

                <Route path="/:uid/places" exact>
                    <UserPlaces />
                </Route>
                
                <Route path="/places/:placeId" exact>
                    <UpdatePlace/>
                </Route>

                <Redirect to="/"/>
            </Switch>
        );
  }
  else{
        routes = (
            <Switch>
                <Route path="/" exact>
                    <Users/>
                </Route>

                <Route path="/:uid/places" exact>
                    <UserPlaces />
                </Route>

                <Route path="/auth" exact>
                    <Auth />
                </Route>
                
                <Redirect to="/auth"/>
            </Switch>
        );
  }


  return (
    <AuthContext.Provider value={
        {
        isLoggedIn: !!token, 
        token: token,
        userId: userId, 
        login: login, 
        logout: logout}
        }
    >
    <Router>
        <MainNav />
        <main>
           <Suspense 
           fallback={
               <div className="center">
                   <LoadingSpinner />
               </div>
           }
           >
                {routes}
           </Suspense>
        </main>
    </Router>
    </AuthContext.Provider>
   
  );
}

export default App;
